import {Component, Input} from '@angular/core';
import {NgIf} from '@angular/common';
import {FormGroup} from '@angular/forms';

@Component({
    selector: 'app-common-date-range-errors',
    standalone: true,
    imports: [
        NgIf
    ],
    templateUrl: './common-date-range-errors.component.html',
    styleUrl: './common-date-range-errors.component.scss'
})
export class CommonDateRangeErrorsComponent {
    @Input({required: true}) form!: FormGroup;
}
